import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Expert } from '../expert-card/expert-card';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-expert-profile-about',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './expert-profile-about.html',
  styleUrl: './expert-profile-about.scss',
})
export class ExpertProfileAboutComponent {
  @Input({ required: true }) expert!: Expert;
}
